export const environment = {
  env: 'stage',
  apiUrl: 'https://stageportal.thelift.mx/',
  backendUrl: 'http://stageportal.thelift.mx/',
  preBidUrl: 'https://stageportal.thelift.mx:8443/',
  production: true
};

export const cineburo_environment = {
  env: 'uat',
  apiUrl: 'https://stageportal.cineburo.com:8443/',
  backendUrl: 'http://stageportal.cineburo.com/',
  preBidUrl: 'https://stageportal.cineburo.com:8443/',
  production: true
};



// WEBPACK FOOTER //
// ./src/environments/environment.stage.ts